import { useSearchParams } from "react-router-dom";
import { ClipboardList, LifeBuoy, Layers } from "lucide-react";
import Orders from "@/pages/Orders";
import Tickets from "@/pages/Tickets";

const VIEWS = [
  { id: "orders", label: "Device orders", icon: ClipboardList },
  { id: "incidents", label: "Incidents", icon: LifeBuoy },
  { id: "all", label: "All", icon: Layers },
];

export default function MyRequests() {
  const [params, setParams] = useSearchParams();
  const view = VIEWS.some((v) => v.id === params.get("view")) ? params.get("view") : "orders";

  return (
    <div className="space-y-6" data-testid="my-requests-page">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">My Requests</div>
          <h1 className="font-display font-black text-3xl text-slate-900 tracking-tight mt-1">Orders, incidents & tickets</h1>
          <p className="text-sm text-slate-600 mt-1">Every ServiceNow record you raised through Flexspace — in one place.</p>
        </div>
        <div className="inline-flex max-w-full overflow-x-auto rounded-full border border-slate-200 bg-slate-100 p-1" data-testid="my-requests-view-switch">
          {VIEWS.map((v) => (
            <button
              key={v.id}
              onClick={() => setParams({ view: v.id })}
              data-testid={`my-requests-view-${v.id}`}
              className={`inline-flex items-center gap-1.5 px-3.5 h-8 whitespace-nowrap rounded-full text-[13px] font-semibold transition-colors ${
                view === v.id ? "bg-white text-[#0033A0] shadow-sm" : "text-slate-600 hover:text-slate-900"
              }`}
            >
              <v.icon size={14} />
              {v.label}
            </button>
          ))}
        </div>
      </div>

      {view === "orders" ? <Orders embedded /> : <Tickets embedded kind={view} />}
    </div>
  );
}
